import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const WeatherMoonFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function WeatherMoonFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="M18 12c-3.31 0-6-2.69-6-6 0-1.93.92-3.65 2.34-4.75C13.59 1.09 12.81 1 12 1 5.92 1 1 5.92 1 12s4.92 11 11 11 11-4.92 11-11c0-.8-.09-1.58-.25-2.34A5.988 5.988 0 0 1 18 12Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default WeatherMoonFilled;